import CreditSVG from "@/../../hypetrain/static/img/credit.svg";
import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";

interface CreditIconProps {
  height: number;
  width: number;
}

export function CreditIcon({ height, width }: CreditIconProps) {
  return (
    <EmbedSvg src={CreditSVG} height={height} width={width} lazy={false} />
  );
}
